export default {
  'APP_SHPGRP_DLVRMTHD_UPDATE': 'APP_SHPGRP_DLVRMTHD_UPDATE',
  'APP_SHPGRP_DLVRADR_UPDATE': 'APP_SHPGRP_DLVRADR_UPDATE',
  'APP_SHPGRP_PCKUP_UPDATE': 'APP_SHPGRP_PCKUP_UPDATE',
  'APP_SHPGRP_CNCL': 'APP_SHPGRP_CNCL'
}